const hittersData = [
  {
    "hitter": "Aaron Graeber",
    "atBats": [
      {
        "inning": 2,
        "pitchType": "Four-Seam Fastball",
        "spinRate": 2074,
        "ev": 100.6,
        "la": 12,
        "pitchHeight": 2.8,
        "result": "Single",
        "distance": 234
      },
      {
        "inning": 4,
        "pitchType": "Curveball",
        "spinRate": 2195,
        "ev": 74.5,
        "la": -17,
        "pitchHeight": 2.3,
        "result": "Single",
        "distance": 12
      }
    ]
  },
  {
    "hitter": "Aaron Whitley",
    "atBats": [
      {
        "inning": 1,
        "pitchType": "Four-Seam Fastball",
        "spinRate": 1925,
        "ev": 71.4,
        "la": -33,
        "pitchHeight": 1.6,
        "result": "Groundout",
        "distance": 5
      },
      {
        "inning": 3,
        "pitchType": "Changeup",
        "spinRate": 1940,
        "ev": 96.4,
        "la": 12,
        "pitchHeight": 2.6,
        "result": "Single",
        "distance": 218
      },
      {
        "inning": 5,
        "pitchType": "Four-Seam Fastball",
        "spinRate": 2063,
        "ev": 75,
        "la": 13,
        "pitchHeight": 3.3,
        "result": "Foul"
      },
      {
        "inning": 7,
        "pitchType": "Curveball",
        "spinRate": 2587,
        "ev": 99.7,
        "la": -1,
        "pitchHeight": 2,
        "result": "Grounded Into DP",
        "distance": 48
      }
    ]
  },
  {
    "hitter": "Carsten Sabathia III",
    "atBats": [
      {
        "inning": 2,
        "pitchType": "Four-Seam Fastball",
        "spinRate": 1875,
        "ev": 87.5,
        "la": 55,
        "pitchHeight": 2.7,
        "result": "Foul"
      },
      {
        "inning": 2,
        "pitchType": "Changeup",
        "spinRate": 1998,
        "ev": 100.6,
        "la": 19,
        "pitchHeight": 2.6,
        "result": "Lineout",
        "distance": 342
      },
      {
        "inning": 4,
        "pitchType": "Four-Seam Fastball",
        "spinRate": 2087,
        "ev": 78.5,
        "la": 3,
        "pitchHeight": 2.9,
        "result": "Foul"
      }
    ]
  },
  {
    "hitter": "Evin Sullivan",
    "atBats": [
      {
        "inning": 8,
        "pitchType": "Slider",
        "spinRate": 2122,
        "ev": 64.8,
        "la": 18,
        "pitchHeight": 1.8,
        "result": "Foul"
      },
      {
        "inning": 8,
        "pitchType": "Four-Seam Fastball",
        "spinRate": 1968,
        "ev": 34.7,
        "la": 54,
        "pitchHeight": 2.6,
        "result": "Pop Out",
        "distance": 66
      },
      {
        "inning": 9,
        "pitchType": "Sinker",
        "spinRate": 1777,
        "ev": 56.9,
        "la": -33,
        "pitchHeight": 2.1,
        "result": "Groundout",
        "distance": 5
      }
    ]
  },
  {
    "hitter": "Harry Genth",
    "atBats": [
      {
        "inning": 9,
        "pitchType": "Sinker",
        "spinRate": 1890,
        "ev": 101.8,
        "la": 0,
        "pitchHeight": 2.5,
        "result": "Single",
        "distance": 44
      }
    ]
  },
  {
    "hitter": "Jaden Sheffield",
    "atBats": [
      {
        "inning": 6,
        "pitchType": "Curveball",
        "spinRate": 2525,
        "ev": 66.8,
        "la": 18,
        "pitchHeight": 2.1,
        "result": "Foul"
      },
      {
        "inning": 9,
        "pitchType": "Four-Seam Fastball",
        "spinRate": 1840,
        "ev": 70,
        "la": 59,
        "pitchHeight": 2.5,
        "result": "Foul"
      },
      {
        "inning": 9,
        "pitchType": "Four-Seam Fastball",
        "spinRate": 2017,
        "ev": 78.4,
        "la": 43,
        "pitchHeight": 3.2,
        "result": "Flyout",
        "distance": 235
      }
    ]
  },
  {
    "hitter": "John Schroeder",
    "atBats": [
      {
        "inning": 1,
        "pitchType": "Four-Seam Fastball",
        "spinRate": 1989,
        "ev": 70.9,
        "la": 46,
        "pitchHeight": 2.9,
        "result": "Foul"
      },
      {
        "inning": 1,
        "pitchType": "Slider",
        "spinRate": 2119,
        "ev": 109.7,
        "la": -23,
        "pitchHeight": 1.7,
        "result": "Foul"
      },
      {
        "inning": 1,
        "pitchType": "Slider",
        "spinRate": 2284,
        "ev": 69.2,
        "la": 79,
        "pitchHeight": 1.8,
        "result": "Foul"
      },
      {
        "inning": 1,
        "pitchType": "Changeup",
        "spinRate": 2067,
        "ev": 61.4,
        "la": 73,
        "pitchHeight": 3.2,
        "result": "Foul"
      },
      {
        "inning": 1,
        "pitchType": "Sinker",
        "spinRate": 2018,
        "ev": 62.8,
        "la": 46,
        "pitchHeight": 2.3,
        "result": "Foul"
      },
      {
        "inning": 1,
        "pitchType": "Slider",
        "spinRate": 2090,
        "ev": 90.3,
        "la": -4,
        "pitchHeight": 2.1,
        "result": "Foul"
      },
      {
        "inning": 3,
        "pitchType": "Changeup",
        "spinRate": 2043,
        "ev": 73.2,
        "la": -35,
        "pitchHeight": 2,
        "result": "Groundout",
        "distance": 6
      },
      {
        "inning": 5,
        "pitchType": "Changeup",
        "spinRate": 1960,
        "ev": 73.9,
        "la": -28,
        "pitchHeight": 1.6,
        "result": "Field Error",
        "distance": 6
      }
    ]
  },
  {
    "hitter": "Justin Fogel",
    "atBats": [
      {
        "inning": 6,
        "pitchType": "Four-Seam Fastball",
        "spinRate": 2392,
        "ev": 67.6,
        "la": -3,
        "pitchHeight": 3.3,
        "result": "Foul"
      },
      {
        "inning": 6,
        "pitchType": "Sinker",
        "spinRate": 2553,
        "ev": 76.9,
        "la": 45,
        "pitchHeight": 3.6,
        "result": "Foul"
      },
      {
        "inning": 6,
        "pitchType": "Sinker",
        "spinRate": 2394,
        "ev": 62.2,
        "la": 45,
        "pitchHeight": 3.2,
        "result": "Foul"
      },
      {
        "inning": 6,
        "pitchType": "Changeup",
        "spinRate": 1546,
        "ev": 77.5,
        "la": -58,
        "pitchHeight": 2.8,
        "result": "Single",
        "distance": 3
      },
      {
        "inning": 8,
        "pitchType": "Sinker",
        "spinRate": 1918,
        "ev": 94.7,
        "la": -7,
        "pitchHeight": 2.3,
        "result": "Groundout",
        "distance": 19
      }
    ]
  },
  {
    "hitter": "Logan Dawson",
    "atBats": [
      {
        "inning": 8,
        "pitchType": "Four-Seam Fastball",
        "spinRate": 1800,
        "ev": 81.2,
        "la": 52,
        "pitchHeight": 2,
        "result": "Flyout",
        "distance": 221
      }
    ]
  },
  {
    "hitter": "Michael Whooley",
    "atBats": [
      {
        "inning": 3,
        "pitchType": "Slider",
        "spinRate": 2230,
        "ev": 46.2,
        "la": 76,
        "pitchHeight": 2.4,
        "result": "Foul"
      },
      {
        "inning": 3,
        "pitchType": "Changeup",
        "spinRate": 1967,
        "ev": 92.2,
        "la": -9,
        "pitchHeight": 1.7,
        "result": "Groundout",
        "distance": 14
      },
      {
        "inning": 5,
        "pitchType": "Four-Seam Fastball",
        "spinRate": 2065,
        "ev": 73.2,
        "la": -42,
        "pitchHeight": 2.7,
        "result": "Groundout",
        "distance": 3
      }
    ]
  },
  {
    "hitter": "Rowan Masse",
    "atBats": [
      {
        "inning": 6,
        "pitchType": "Sinker",
        "spinRate": 2382,
        "ev": 74.5,
        "la": 33,
        "pitchHeight": 3,
        "result": "Foul"
      },
      {
        "inning": 6,
        "pitchType": "Curveball",
        "spinRate": 2536,
        "ev": 91.1,
        "la": 7,
        "pitchHeight": 1.9,
        "result": "Double Play",
        "distance": 160
      }
    ]
  },
  {
    "hitter": "Taylor Belza",
    "atBats": [
      {
        "inning": 4,
        "pitchType": "Slider",
        "spinRate": 2092,
        "ev": 86.3,
        "la": 47,
        "pitchHeight": 2.4,
        "result": "Flyout",
        "distance": 250
      },
      {
        "inning": 9,
        "pitchType": "Sinker",
        "spinRate": 2013,
        "ev": 95.5,
        "la": 6,
        "pitchHeight": 2.3,
        "result": "Single",
        "distance": 111
      }
    ]
  },
  {
    "hitter": "Jakob Poturnak",
    "atBats": [
      {
        "inning": 2,
        "result": "Lineout",
        "ev": 78.3,
        "la": 12,
        "distance": 155
      },
      {
        "inning": 4,
        "result": "Single",
        "ev": 89.9,
        "la": 5,
        "distance": 99
      }
    ]
  },
  {
    "hitter": "JuJu Stevens",
    "atBats": [
      {
        "inning": 4,
        "result": "Flyout",
        "ev": 103.1,
        "la": 31,
        "distance": 381
      }
    ]
  }
];
export default hittersData;
